import { render } from "./cp_header_title.vue?vue&type=template&id=5d56cca6&scoped=true"
import script from "./cp_header_title.vue?vue&type=script&lang=js"
export * from "./cp_header_title.vue?vue&type=script&lang=js"

import "./cp_header_title.vue?vue&type=style&index=0&id=5d56cca6&scoped=scoped&lang=css"

import exportComponent from "E:\\WorkCode\\HZYNew\\Code\\HZY.Student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d56cca6"]])

export default __exports__